import React from "react"
import { useTranslation } from "next-i18next"
import { styled } from "twin.macro"

import NotFoundIcon from "@assets/svgx/NotFoundIcon"

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 50px 20px;
`

const Text = styled.span`
    text-align: center;
`
const Subtitle = styled.span`
    text-align: center;
`

interface EmptyProps {
    className?: string
    image?: string | React.ReactNode
    text?: React.ReactNode
    subtitle?: string | React.ReactNode
}

const Empty: React.FC<EmptyProps> = ({ className, image, text, subtitle }) => {
    const { t } = useTranslation("common")

    return (
        <Wrapper className={className}>
            {image || <NotFoundIcon width={140} height={140} />}
            <Text>{text || t("common:message.no_data")}.</Text>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Wrapper>
    )
}

Empty.defaultProps = {
    className: undefined,
    image: undefined,
    text: undefined,
    subtitle: undefined
}

export default Empty
